export const emptyParcellesWorkerCode = `
self.onmessage = (e) => {
  try {
    const { parcellesPages, batimentsPages } = e.data;
    const egridWithBuildings = new Set();
    for (const page of batimentsPages) {
      const batFeatures = page?.features || [];
      for (const f of batFeatures) {
        const list = (f?.attributes?.egrid_liste || f?.attributes?.EGRID_LISTE || '').toString();
        if (!list) continue;
        list.split(',').map(s => s.trim()).filter(Boolean).forEach(e => egridWithBuildings.add(e));
      }
    }
    // Return only attributes and simple rings to main thread (light)
    const result = [];
    for (const page of parcellesPages) {
      const feats = page?.features || [];
      for (const f of feats) {
        const attrs = f?.attributes || {};
        const egrid = attrs.egrid || attrs.EGRID;
        const typePropri = (attrs.type_propri || '').toString();
        const isExcludedType = typePropri === 'DP communal' || typePropri === 'DP cantonal (hors indice)' || typePropri === 'DP cantonal';
        if (!egrid || egridWithBuildings.has(egrid) || isExcludedType) continue;
        const geom = f?.geometry;
        if (geom && geom.rings && geom.rings.length) {
          result.push({ rings: geom.rings[0] });
        }
      }
    }
    self.postMessage({ ok: true, result });
  } catch (err) {
    self.postMessage({ ok: false, error: err?.message || 'error' });
  }
};
`; 